import { render, staticRenderFns } from "./ExplanationIcon.vue?vue&type=template&id=68867695&scoped=true&"
import script from "./ExplanationIcon.vue?vue&type=script&lang=js&"
export * from "./ExplanationIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68867695",
  null
  
)

export default component.exports